import React, { useState } from "react";
import { FaFilter } from "react-icons/fa";
import Dropdown from "../../Components/DropDown";

const FilterDropdown = ({ value, onChange }) => {
  // const [open, setOpen] = useState(false);
  const statusOptions = ["present", "weekend", "holiday", "absent"];
  const locationOptions = [
    { label: "Office", value: "office" },
    { label: "Remote", value: "remote" },
  ];
  // const close = () => setOpen(false);

  return (
    <Dropdown label="Filter by" icon={FaFilter}>
       {(close) => (
      <div className="py-2 w-50">
        {/* Status */}
        <div className="px-3 py-2">
          <p className="text-xs font-semibold text-gray-500 mb-1">Status</p>
          <ul className="space-y-1">
            {statusOptions?.map((status) => (
              <li
                key={status}
                className={`px-3 py-1 rounded cursor-pointer text-sm capitalize ${
                  value?.status === status
                    ? "bg-blue-50 text-blue-600 font-medium"
                    : "hover:bg-gray-100"
                }`}
                onClick={() =>{ onChange({ status }); close();}}
              >
                {status}
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t mt-2" />
        <div className="px-3 py-2">
          <p className="text-xs font-semibold text-gray-500 mb-1">
            Work Mode
          </p>
          <ul className="space-y-1">
            {locationOptions?.map((loc) => (
              <li
                key={loc?.value}
                className={`px-3 py-1 rounded cursor-pointer text-sm ${
                  value?.work_location === loc?.value
                    ? "bg-blue-50 text-blue-600 font-medium"
                    : "hover:bg-gray-100"
                }`}
                onClick={() => { onChange({ work_location: loc?.value }); close(); }}
              >
                {loc?.label}
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t my-2" />

        <button
          className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:bg-gray-100"
          onClick={() => { onChange({ status: "", work_location: "" }); close(); }}
        >
          Clear filters
        </button>
      </div>
       )}
    </Dropdown>
  );
};

export default FilterDropdown;